import moment from 'moment';
import {
  AtendimentosPorcemPerfisProps,
  FormattedApexChart,
  TotalAtendimentosPorte,
  TotalPerfilUsuarioSas,
} from '../dashboard.interfaces';
import { mockCategories } from '../../../components/Charts/Line/chartDataMocks';

const mockSeriesPorte = {
  data1: [45, 52, 38, 24, 33, 26, 21, 20, 6, 8, 15, 10, 12, 51],
  data2: [35, 41, 62, 42, 13, 18, 29, 37, 36, 51, 32, 35, 112, 51],
  data3: [87, 57, 74, 99, 75, 38, 62, 47, 82, 56, 45, 47, 87, 67],
  data4: [92, 105, 41, 78, 56, 113, 75, 40, 88, 57, 99, 65, 42, 114],
  data5: [104, 89, 60, 42, 95, 78, 113, 50, 72, 38, 110, 58, 85, 101],
};

export function formattedPerfilUsuarioSas(
  data: TotalPerfilUsuarioSas | undefined
): FormattedApexChart {
  if (!data) {
    return {
      series: [],
      categories: { categories: [] },
      total: 0,
    };
  }

  const series = [
    {
      name: 'Total',
      data: data.atendimentos.map((perfil) => perfil.totalPf + perfil.totalPj),
    },
    {
      name: 'Pessoa Física',
      data: data.atendimentos.map((perfil) => perfil.totalPf),
    },
    {
      name: 'Pessoa Jurídica',
      data: data.atendimentos.map((perfil) => perfil.totalPj),
    },
  ];

  const categories = {
    categories: data.atendimentos.map((item) =>
      moment(item.data).format('DD MMM')
    ),
  };

  const somarOcorrencias = (
    acumulador: Partial<AtendimentosPorcemPerfisProps>,
    atendimento: Partial<AtendimentosPorcemPerfisProps>
  ) => {
    acumulador.totalPf! += atendimento.totalPf!;
    acumulador.totalPj! += atendimento.totalPj!;
    return acumulador;
  };
  const somaTotal = data.atendimentos.reduce(somarOcorrencias, {
    totalPf: 0,
    totalPj: 0,
  });

  const total = somaTotal.totalPf! + somaTotal.totalPj!;

  return {
    series,
    categories,
    total,
  };
}

export function formattedPorte(data: TotalAtendimentosPorte) {
  if (!data) {
    return {
      series: [],
      categories: { categories: [] },
      total: 0,
    };
  }
  const series = [
    {
      name: 'MEI',
      // data: data.atendimentos[0].total,
      data: mockSeriesPorte.data5,
    },
    {
      name: 'ME',
      // data: data.atendimentos[1].total,
      data: mockSeriesPorte.data3,
    },
    {
      name: 'EPP',
      // data: data.atendimentos[2].total,
      data: mockSeriesPorte.data1,
    },
    {
      name: 'MED',
      // data: data.atendimentos[3].total,
      data: mockSeriesPorte.data2,
    },
    {
      name: 'GRA',
      // data: data.atendimentos[4].total,
      data: mockSeriesPorte.data4,
    },
  ];

  const categories = {
    // categories: data.atendimentos.map((item: any) => item.sigla),
    categories: mockCategories.categories,
  };

  const total = data.total;

  return {
    series,
    categories,
    total,
  };
}
